import AxiosInstance from '../../helpers/axios-instance/axios-instance';
import { appConfig } from '../../helpers/app-config/app-config';
import type { AuditLogSparklineApiResponse, AuditLogSparklineParams } from './audit-logs-client.type';

const axiosInstance = AxiosInstance();
const baseURL = appConfig.VITE_APP_API_URL + '/api/';

/**
 * Fetches audit log sparkline data for visualization
 * Fetches weekly activity counts for multiple projects to display as sparklines
 *
 * @param {AuditLogSparklineParams} params Query parameters for the sparkline endpoint
 * @return {Promise<AuditLogSparklineApiResponse>} A promise that resolves to sparkline data by project ID
 */
const getAuditLogSparkline = (params: AuditLogSparklineParams): Promise<AuditLogSparklineApiResponse> => {
  const queryParams = new URLSearchParams();

  // Add required project_ids parameter as comma-separated values: ?project_ids=uuid1,uuid2,uuid3
  queryParams.append('project_ids', params.project_ids.join(','));

  if (params.start_date) queryParams.append('start_date', params.start_date);
  if (params.end_date) queryParams.append('end_date', params.end_date);

  const apiURL = baseURL + `audit-logs/sparklines/${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;

  return axiosInstance
    .get(apiURL)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error?.response?.data || 'Error while fetching audit log sparkline data'));
};

export { getAuditLogSparkline };
